import { createReducer, AsyncRequest } from 'angieslist-app-platform';
import { get } from 'lodash';
import { combineReducers } from 'redux';
import Immutable from 'immutable';
import homeActionKeys from './homeActionKeys';
import userActionKeys from '../../../app/common/user/userActionKeys';
import { sendHomePageVisitEvent } from './homeActions';
import serviceProviderActions from '../../../app/common/serviceProvider/serviceProviderActions';


const viewedWelcomeModal = createReducer(new Immutable.Map(), {
  [homeActionKeys.MARK_MODAL_SEEN]: (state, action) => state.set(action.payload.spid, true),
}, true);

const sentHomePageVisitEvent = createReducer(false, {
  [userActionKeys.GET_USER_SUCCESS]: (state, action) => {
    if (!state) {
      action.addSideEffect((store) => {
        store.dispatch(sendHomePageVisitEvent());
      });
      return true;
    }
    return state;
  },
});

export default combineReducers({
  viewedWelcomeModal,
  sentHomePageVisitEvent,
  getAllHighlights: AsyncRequest.createReducer(homeActionKeys.GET_ALL_HIGHLIGHTS),

  updateBusinessHighlights: AsyncRequest.createReducer(homeActionKeys.UPDATE_BUSINESS_HIGHLIGHTS, {
    [homeActionKeys.UPDATE_BUSINESS_HIGHLIGHTS_SUCCESS]: (state, action) => {
      action.addSideEffect((store) => {
        const storeState = store.getState();
        const serviceProviderId = get(storeState, 'serviceProviderId');

        store.dispatch(serviceProviderActions.getServiceProvider(serviceProviderId));
      });
      return AsyncRequest.setSuccess(state, action.payload);
    },
  }),

});



// WEBPACK FOOTER //
// ./src/modules/home/common/homeReducer.js